/* eslint-disable react/prop-types */
import { useDispatch } from "react-redux";
import Dropdown from "@shared/v2/Dropdown";
import CALL_STATES from "../utils/states";

import { dialerProps, dialerDefaults } from "../shared";

const SinglePerson = ({ loading, callState, person, phoneNumbers, phoneNumber, setPhoneNumber }) => {
  const dispatch = useDispatch();

  if (loading) return <span />;
  return (
    <div className="tw-flex tw-flex-col tw-gap-[8px]">
      <span className="tw-text-18d tw-font-bold tw-leading-[18px]">{person?.fullName || "No Name"}</span>
      <Dropdown
        className="tw-min-w-[240px]"
        options={phoneNumbers}
        value={phoneNumber}
        isDisabled={callState !== CALL_STATES.Init}
        onChange={(p) => dispatch(setPhoneNumber(p))}
      />
    </div>
  );
};

export default SinglePerson;

SinglePerson.propTypes = {
  ...dialerProps.loading,
  ...dialerProps.callState,
  ...dialerProps.person,
  ...dialerProps.phoneNumbers,
  ...dialerProps.phoneNumber,
  ...dialerProps.setPhoneNumber,
};

SinglePerson.defaultProps = {
  ...dialerDefaults.loading,
  ...dialerDefaults.callState,
  ...dialerDefaults.person,
  ...dialerDefaults.phoneNumbers,
  ...dialerDefaults.phoneNumber,
  ...dialerDefaults.setPhoneNumber,
};
